import type { ConnectorFeatureInvocationSequence } from '@/adapters/apiv1.g';
import type { ConnectorFeatureCurrentSequence } from '@/types/core/connector';

/**
 * Normalize invocation sequence payload from API shape to UI domain shape.
 */
export function extractInvocationSequence(
  model: ConnectorFeatureInvocationSequence
): ConnectorFeatureCurrentSequence {
  const parsedSequence = Number(model.sequence_num ?? '0');
  const sequenceNum =
    Number.isInteger(parsedSequence) && parsedSequence >= 0
      ? parsedSequence
      : 0;

  return {
    inFlight: Boolean(model.in_flight),
    sequenceNum,
  };
}
